import React from 'react';
import PropTypes from 'prop-types';
import Flex from '../../common/Flex';
// import SoftBadge from '../../common/SoftBadge';
import Avatar from '../../common/Avatar';
import SoftBadge from '../../common/SoftBadge';

function NavbarVerticalMenuItem({ section }) {
  return (
    <Flex alignItems="center">
      {/* {section.icon && ( */}
      {/*  <span className="nav-link-icon"> */}
      {/*    <img src={section.icon} alt={section.label} /> */}
      {/*  </span> */}
      {/* )} */}
      <Avatar
        size="xl"
        name={section.label}
        className="navbar-children-avatar"
        mediaClass="text-nowrap bg-400 text-dark "
      />
      <span className="nav-link ps-1 navbar-children-text">
        {section.label}
      </span>
      {section.badge && (
      <SoftBadge pill bg={section.badge.type} className="ms-2">
        {section.badge.text}
      </SoftBadge>
      )}
    </Flex>
  );
}

// prop-types
const routeShape = {
  name: PropTypes.string,
  label: PropTypes.string.isRequired,
  resource: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
};
routeShape.children = PropTypes.arrayOf(PropTypes.shape(routeShape));
NavbarVerticalMenuItem.propTypes = {
  section: PropTypes.shape(routeShape).isRequired,
};

export default React.memo(NavbarVerticalMenuItem);
